import React from 'react';
import Select from 'react-select';

export default function PartyFilter({parties, setFilter}) {
    const formattedParties = parties.map(party => ({ value: party, label: party }))
    const theme = theme => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: '#9575CD',
          primary25: '#faf5ff',
          primary50: '#d6bcfa',
          neutral20: '#e2e8f0',
          neutral30: '#cbd5e0'
        }})
    return (
        <div className="w-64 mr-5">
            <label className="block tracking-wide text-gray-600 text-xs font-bold mb-2" htmlFor="partyFilter">
                Filter by Party ID
            </label>
            <Select 
                id="partyFilter" 
                onChange={(v) => setFilter("IdKey",v ? v.value : undefined)} 
                options={formattedParties}
                isClearable={true}
                theme={theme}
                className="text-gray-800"
                />
        </div>
    )
}